import { Capacitor } from "@capacitor/core"
import type { PlayVideoOptions } from "../../capacitor-valor-player/src/definitions"

/**
 * Try to play video using native player plugin
 * Returns true if native player is available and started, false otherwise
 */
export async function tryNativePlayer(options: PlayVideoOptions): Promise<boolean> {
	// Only attempt native playback on iOS or Android platforms
	if (!Capacitor.isNativePlatform()) {
		// console.log("Not a native platform, skipping native player")
		return false
	}

	try {
		// Dynamically import the plugin to avoid errors on web
		const { CapacitorValorPlayer } = await import("../../capacitor-valor-player/src")

		// console.log("Attempting to play video with native player:", options)
		await CapacitorValorPlayer.playVideo(options)
		// console.log("Native player started successfully")
		return true
	} catch (error) {
		console.warn("Native player not available or failed to start:", error)
		return false
	}
}
